import BasicService from "../service/BasicService";

class BranchService extends BasicService {
  constructor() { 
    super();
  }
 
  getAllBranch() {
    let url = "/branches";
    return this.axios.get(url).then(request => request.data);
  }

  deleteBranch(branch){
    let url = `/branches/${branch.branchId}`;
    return this.axios.delete(url,branch).then(request => request.data);
  }
  updateBranch(branch){
    let url = `/branches/${branch.branchId}`;
    return this.axios.put(url,branch).then(request => request.data);
  }
  addBranch(branch) {
    let url = `/branches`;
    return this.axios.post(url,branch).then(request => request.data);
  }
  getBranchesUser() {
    let url = "/branches/user";
    return this.axios.get(url).then(request => request.data);
  }
}

const branchService = new BranchService();
export default branchService;
